import {$dom} from "../../helpers/dom";
import Component from "../../classes/Component";
import {$events} from "../../helpers/events";

const {toggleClass, hasClass, get} = $dom

const dynamicRenderOrderSelector = '.js-dynamic-render-orders'

// Это данные, которые мы получаем от сервера, допустим методом fetch. Прост я их тут пока захардкодил
const orders = [
    {
        id: 1,
        title: 'Заказ 45654 от 25.08.2021',
        coast: '6 500 ₽',
        count: '5 товаров',
        type: 'Доставлен',
        orders: [{title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'}]
    },
    {
        id: 2,
        title: 'Заказ 45654 от 25.08.2021',
        coast: '6 500 ₽',
        count: '5 товаров',
        type: 'Собирается',
        orders: [{title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'}]
    },
    {
        id: 3,
        title: 'Заказ 45654 от 25.08.2021',
        coast: '6 500 ₽',
        count: '5 товаров',
        type: 'Доставлен',
        orders: [{title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'}]
    },
    {
        id: 4,
        title: 'Заказ 45654 от 25.08.2021',
        coast: '6 500 ₽',
        count: '5 товаров',
        type: 'Доставлен',
        orders: [
            {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'},
            {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '380 ₽', count: '1 шт'},
            {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '4 шт'},
            {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '4 шт'},
            {title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '4 шт'},
        ]
    },
    {
        id: 5,
        title: 'Заказ 45654 от 25.08.2021',
        coast: '6 500 ₽',
        count: '5 товаров',
        type: 'Доставлен',
        orders: [{title: 'Конфеты шоколадные с кофейной, коньячной и ореховой начинкой', coast: '580 ₽', count: '1 шт'}]
    },
]

export default function () {
    const getOrders = (item) => {
        let resultHTML = ''

        for (let i = 0; i < item.orders.length; i++) {
            resultHTML += `
                <div class="col-md-4 col-12 mb-md-0 mb-sm-4 mb-4">
                    <div class="d-flex justify-content-between">
                        <div>
                            <img src="./img/order/image.jpg" width='73' height='60' alt="">
                        </div>
                            
                        <div class="ms-1 orders__description">
                            <p class="mb-3 text--regular">${item.orders[i].title}</p>
                            
                            <div class="d-flex">
                                <p class="me-3 text--regular">${item.orders[i].count}</p>
                                
                                <p class="text--regular">${item.orders[i].coast}</p>
                            </div>
                        </div>
                    </div>
                </div>
            `
        }

        return resultHTML
    }

    const handleResizeWindow = () => {
        if (window.matchMedia("(min-width: 767px)").matches) {
            const HTMLStart = `<div class="row d-md-block d-sm-none d-none">`
            const HTMLEnd = '</div>'

            let HTML = ''

            orders.forEach(item => {
                HTML += `
                    <div class="orders__tab">
                        <input type="checkbox" name="acc" id="acc${item.id}" class="d-none"/>
                        <label for="acc${item.id}">
                            <div>
                                <h6 class="title">${item.title}</h6>
                                ${item.type === 'Доставлен' ? '<p class="text--darkgray text--regular mb-0">Доставлено</p>' : '<p class="text--lightgreen text--regular mb-0">Собирается</p>'}
                            </div>
                            
                            <div class="d-flex align-items-center">
                                 <div class="orders__price">
                                     <h6 class="title">${item.coast}</h6>
                                     <p class="text--darkgray text--regular m-0">${item.count}</p>  
                                 </div>  
                                 
                                 <svg class="svg-icon orders__item-icon d-md-block d-sm-none d-none" width="12px" height="12px">
                                     <use xlink:href="../storepobeda/img/sprite.svg#arrow-down"></use>
                                </svg>
                          
                                <svg class="svg-icon orders__item-icon d-md-block d-sm-none d-none" width="12px" height="12px">
                                    <use xlink:href="../storepobeda/img/sprite.svg#arrow-up"></use>
                                </svg>                    
                            </div>
                        </label>
                        <div class="orders__tab-content">
                            <div>
                                <hr />
                            
                                <div class="row row-cols-3 ms-2 mt-1 mb-4 gy-3">
                                     ${getOrders(item)}
                                </div>  
                                
                                <div class="d-flex justify-content-between mt-3 mx-5">
                                    <p class="text--medium">Начислено бонусов</p>
                                    <p class="text--medium">15</p>
                                </div>         
                                
                                <div class="d-flex justify-content-between mt-1 mx-5">
                                    <p class="text--medium">Доставка курьером Ozon</p>
                                    <p class="text--medium">150 ₽</p>
                                </div>   
                                
                                <div class="d-flex justify-content-between px-4 py-3 orders__item-accordion-price mx-4">
                                    <p class="text--medium mb-0 text--extra-large">Всего</p>
                                    <p class="text--medium mb-0 text--extra-large">6 500 ₽</p>
                                </div>    
                                
                                <div class="d-flex mt-4 mx-1 flex-md-row flex-sm-column flex-column ms-5">
                                    <div class="orders__column-1">
                                        <p class="text--gray mb-sm-2 mb-2 mb-md-4">Получатель</p>
                                        <p class="mb-0">Владимиров Владислав</p>
                                        <p class="mb-0 text--regular">+ 7 (898) 654-65-56</p>
                                    </div>
                                    
                                    <div class="orders__column-hr d-md-none d-sm-block d-block">
                                        <hr>
                                    </div>
                                    
                                    <div class="orders__column-2">
                                        <div>
                                            <p class="text--gray mb-sm-2 mb-2 mb-md-4">Адрес доставки</p>
                                            <p class="mb-0">г. Москва, берсеневская наб., 16/1, 65</p>
                                            <p class="mb-0 text--regular">Курьер Ozon</p>
                                        </div>
                                    </div>
                                    
                                    <div class="orders__column-hr d-md-none d-sm-block d-block">
                                        <hr>
                                    </div>
                                    
                                    <div class="orders__column-3">
                                        <div>
                                            <p class="text--gray mb-sm-2 mb-2 mb-md-4">Оплата</p>
                                            <p class="mb-0">Картой онлайн</p>
                                        </div>
                                    </div>
                                    
                                    ${item.type === 'Собирается' ? '<div class="orders__column-button me-4"><button class="button--default w-100 mt-2 orders__information-button">Оплатить сейчас</button></div>' : ''}
                                </div> 
                                
                                ${item.type === 'Доставлен' ? '<div class="orders__column-button ms-4 orders__information-repeat"><button class="button--default w-100 orders__information-button ">Повторить заказ</button></div>' : ''}
                            </div>          
                        </div>      
                    </div>
                `
            })

            HTML = HTMLStart + HTML + HTMLEnd

            get(dynamicRenderOrderSelector).innerHTML = HTML
        } else {
            const HTMLStart = `<div class="row d-md-none d-sm-block d-block">`
            const HTMLEnd = '</div>'

            let HTML = ''

            orders.forEach(item => {
                HTML += `
                    <button data-id="${item.id}" class="js-offcanvas-order" type="button" data-bs-toggle="offcanvas" data-bs-target="#js-offcanvas-order">
                        <div class="col-12 mb-3">
                            <div class="orders__item border d-flex justify-content-between p-md-4 py-sm-3 ps-sm-5 pe-sm-2 py-3 ps-5 pe-2">
                                <div>
                                    <h6 class="title">${item.title}</h6>
                                    ${item.type === 'Доставлен' ? '<p class="text--gray text--regular mb-0 text-start">Доставлено</p>' : '<p class="text-start text--lightgreen text--regular mb-0">Собирается</p>'}
                                </div>
                                
                                <div class="d-flex align-items-center">
                                     <div class="me-md-5 me-sm-3 me-3">
                                         <h6 class="title">${item.coast}</h6>
                                         <p class="text--gray text--regular m-0">${item.count}</p>  
                                     </div>  
                                     
                                     <svg class="svg-icon orders__item-icon d-md-block d-sm-none d-none" width="12px" height="12px">
                                         <use xlink:href="../storepobeda/img/sprite.svg#arrow-down"></use>
                                    </svg>
                              
                                    <svg class="svg-icon orders__item-icon d-ms-none d-sm-block d-block" width="12px" height="12px">
                                        <use xlink:href="../storepobeda/img/sprite.svg#arrow-right"></use>
                                    </svg>                    
                                </div>                            
                            </div>
                        </div>
                    </button>
                `
            })

            HTML = HTMLStart + HTML + HTMLEnd

            get(dynamicRenderOrderSelector).innerHTML = HTML
        }
    }

    const fetchOrders = () => {
        // отправляется fetch запрос, чтобы получить закказы
        // fetch(...)
    }

    return new Component({
        name: 'dynamicRender',
        requiredTargets: [dynamicRenderOrderSelector],
        onInit() {
            fetchOrders()
            handleResizeWindow()
            $events.delegate.on('resize', window, handleResizeWindow)
        },
        onDestroy() {
            $events.delegate.off('resize', window, handleResizeWindow)
        },
    })

}